var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenovated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60308 7.20006L8.18888 8.61426L12.1864 12.6117L13.6006 11.1975L9.60308 7.20006Z",
    fill: "#222222",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6671 5.16621C11.9537 5.16621 13.0004 4.11954 13.0004 2.83288C13.0004 2.44621 12.8937 2.08621 12.7271 1.76621L10.9271 3.56621L9.93372 2.57288L11.7337 0.772878C11.4137 0.606211 11.0537 0.499544 10.6671 0.499544C9.38039 0.499544 8.33372 1.54621 8.33372 2.83288C8.33372 3.10621 8.38706 3.36621 8.47372 3.60621L7.24039 4.83954L6.05372 3.65288L6.52706 3.17954L5.58706 2.23954L7.00039 0.826211C6.22039 0.0462109 4.95372 0.0462109 4.17372 0.826211L1.81372 3.18621L2.75372 4.12621H0.873724L0.400391 4.59954L2.76039 6.95954L3.23372 6.48621V4.59954L4.17372 5.53954L4.64706 5.06621L5.83372 6.25288L0.893724 11.1929L2.30706 12.6062L9.89372 5.02621C10.1337 5.11288 10.3937 5.16621 10.6671 5.16621Z",
    fill: "#222222",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenovated);
export default __webpack_public_path__ + "static/media/renovated.2493ab2123a6fb85b360247ecc807eb3.svg";
export { ForwardRef as ReactComponent };